import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { StyleGuideView } from '../components/views/styleGuideView'

/** Admin > Style guide: living reference for the `ui` component library. */
function StyleGuide() {
    return (
        <div className="styleGuide">
            <Sidebar />
            <MainView>
                <StyleGuideView />
            </MainView>
        </div>
    )
}

export default StyleGuide
